import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/services/auth-context';
import { getPlatformLoginUrl } from '@/services/platform-login';

/**
 * Kosh does not host its own sign-in form. Anyone landing at
 * `kosh.zafroi.com/login` is immediately bounced to the canonical
 * `zafroi.com/login` (which is the single source of truth for ZAFROI
 * credentials). After successful sign-in there, the cross-subdomain
 * refresh cookie + the `?from=` query param bring the user back here.
 *
 * Already-authenticated users (back button, deep link) skip the bounce
 * and go to /dashboard.
 */
export function LoginPage() {
  const navigate = useNavigate();
  const { status } = useAuth();

  React.useEffect(() => {
    if (status === 'authenticated') {
      navigate('/dashboard', { replace: true });
      return;
    }
    if (status === 'unauthenticated') {
      // We're already on /login — using window.location.href as the `from`
      // would just loop the user back here. Use /dashboard as the return.
      const dashboardHref = `${window.location.origin}/dashboard`;
      window.location.replace(getPlatformLoginUrl({ from: dashboardHref }));
    }
  }, [status, navigate]);

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
    </div>
  );
}
